import { useTrack } from "@/hooks/useTrack/useTrack";

import { useTrackHelpers } from "@/hooks/useTrackHelpers/useTrackHelpers";
import { useCall } from "../useCall/useCall";

export function useTrackAudioSkip() {
  const { track } = useTrack();
  const { call } = useCall();

  const { transcription_displayed } = useTrackHelpers();

  const onClick =
    (event: "audio_skip_forward" | "audio_skip_backward") => () => {
      track(event, {
        call_uuid: call?.uuid,
        call_id: call?.id,
        transcription_displayed,
      });
    };

  return { onClick };
}
